// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2025-2026 Daragh Farrell

import Logo from '../Logo';

interface BiometricPromptProps {
  biometricLabel: string;
  onCancel: () => void;
}

/** Shown while biometric authentication is in progress */
export default function BiometricPrompt({ biometricLabel, onCancel }: BiometricPromptProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-b from-brand-50 via-white to-white px-4 py-10">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-md text-center">
        <div className="mb-4 flex justify-center">
          <Logo variant="full" size="lg" />
        </div>
        <p className="mb-4 text-sm text-slate-600" aria-live="polite">
          Authenticating with {biometricLabel}...
        </p>
        <button
          type="button"
          onClick={onCancel}
          data-testid="biometric-cancel"
          className="text-sm font-medium text-brand-600 hover:text-brand-700"
        >
          Use password instead
        </button>
      </div>
    </div>
  );
}
